export default __webpack_public_path__ + "static/media/sms.202b0dd5.gif";